import React, { useLayoutEffect, useState } from 'react'
import { Link } from 'gatsby'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DynamicZoneMainHeader from '../../helpers/dynamicZoneMainHeader'
import useAllSitePage from '../../hooks/useAllSitePage'
import { useTheme } from '../../context/themeContext'
import { InternalLink } from '../../shared/Links/InternalLink'
import { ExternalLink } from '../../shared/Links/ExternalLink'
import { useDispatch } from 'react-redux'
import { toggleMenu } from '../../state/actions/menuActions'
import './HeaderHome.scss'

const HeaderHome = ({ screenData }) => {
  
  const homePosgradoUcc = screenData
  const pagesPath = useAllSitePage()

  const { 
    allSitePage: matchPages
  } = pagesPath

  const { theme, toggleTheme } = useTheme()

  // Utiliza el estado global de menuMobileActive
  const dispatch = useDispatch()

  const handleClickMenuMobile = () => {
    dispatch(toggleMenu())
  }

  // Calculando Scroll actual
  const [ scrollPosition, setScrollPosition ] = useState(0)

  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])

  const careerFeedByLevel = [
    {
      name: "Doctorados",
      slug: "/propuesta-academica?nivel=Doctorados"
    },
    {
      name: "Maestrías",
      slug: "/propuesta-academica?nivel=Maestrías"
    },
    {
      name: "Especializaciones",
      slug: "/propuesta-academica?nivel=Especializaciones"
    },
    {
      name: "Especialidades Médicas",
      slug: "/propuesta-academica/especialidades-medicas"
    },
    {
      name: "Ver Propuesta Académica",
      slug: "/propuesta-academica"
    },
  ]

  return (
    <header className={`fixed-top ${scrollPosition > 577 ? 'nav-primary-container' : 'nav-primary-container-home'}`}>
      <Navbar
        expand="lg"
        className={`mx-auto flex-lg-column pt-lg-3 px-3 navbar-scroll
          ${scrollPosition > 577 ? 'w-100 shadow' : ''} 
        `}
        bg={`${scrollPosition > 577 ? 'navbar-scroll-style2' : 'navbar-scroll-style'}`}
        variant={`${scrollPosition > 577 ? theme : 'dark'}`}
      >
        <div className="w-100 d-flex flex-column flex-lg-row">
          <div className="flex-grow-1 d-flex flex-row align-items-center">
            {/* Imagen del Navbar */}
            <Navbar.Brand>
              <Link to={homePosgradoUcc.primaryLogo?.url ? homePosgradoUcc.primaryLogo.url : '/'}>
                <img
                  src={homePosgradoUcc.primaryLogo?.image?.url
                    // Config con Navbar claro
                    // scrollPosition > 577
                    //   ? (theme === 'dark' && homePosgradoUcc.secondaryLogoDark
                    //       ? homePosgradoUcc.secondaryLogoDark?.image.url
                    //       : homePosgradoUcc.secondaryLogo?.image.url
                    //     ) || 
                    //     homePosgradoUcc.primaryLogo?.image?.url
                    //   : homePosgradoUcc.primaryLogo?.image?.url
                  }
                  alt={
                    homePosgradoUcc.primaryLogo?.name ||
                    homePosgradoUcc.secondaryLogo?.name ||
                    'UCC'
                  }
                  className="logoHeader me-2"
                />
              </Link>
            </Navbar.Brand>

            {/* Mobile Navbar */}
            <Navbar.Toggle
              aria-controls="index-navbar-nav"
              className="ms-auto border-0"
              onClick={handleClickMenuMobile}
            />
          </div>

          {/* Button theme on laptop */}
          <div className="d-flex flex-column">
            <div className="flex-grow-1 d-none d-lg-flex align-items-center justify-content-start justify-content-md-end navbar-nav fw-bolder nav-primary">
              <div className="d-flex">
                <div className={`btn-sm ${scrollPosition > 577 ? 'nav-primary-color' : 'text-white'}`}>
                  <button onClick={toggleTheme} className="theme-toggle">
                    {theme === 'dark' ? <FontAwesomeIcon icon="fa-solid fa-moon" /> : <FontAwesomeIcon icon="fa-solid fa-sun" />}
                  </button>
                </div>
              </div>
              <DynamicZoneMainHeader
                homeData={homePosgradoUcc}
                matchPages={matchPages}
                position={scrollPosition}
              />
            </div>
          </div>
        </div>

        <Navbar.Collapse id="index-navbar-nav" className="w-100">
          {/* Button theme on mobile */}
          <div className="row">
            <div className="col">
              <div className="d-lg-none d-flex align-items-center justify-content-start justify-content-md-end navbar-nav border-top border-bottom py-3 fw-bolder nav-primary">
                <div className="d-lg-none d-flex">
                  <div className={`btn-sm ${scrollPosition > 577 ? 'nav-primary-color' : 'text-white'}`}>
                    <button onClick={toggleTheme} className="theme-toggle">
                      {theme === 'dark' ? <FontAwesomeIcon icon="fa-solid fa-moon" /> : <FontAwesomeIcon icon="fa-solid fa-sun" />}
                    </button>
                  </div>
                </div>
                <DynamicZoneMainHeader
                  homeData={homePosgradoUcc}
                  matchPages={matchPages} 
                  position={scrollPosition} 
                />
              </div>
            </div>
          </div>
          
          <Nav
            id='header-home-navbar'
            className={`ms-auto flex-column flex-lg-row ${
              scrollPosition < 577 
                ? 'link-dropdown-white' 
                : 'link-dropdown-dark'
            }`}
          >
            {homePosgradoUcc.navbar?.map((menuItem, index) => {
              if (
                /********* Map para navItems simples *********/
                menuItem.p_ucc_microsite ||
                menuItem.p_ucc_page ||
                menuItem.url
              ) {
                if (menuItem.p_ucc_microsite && menuItem.p_ucc_microsite.slug) {
                  return (
                    <InternalLink
                      key={'internalLink-navbar-microsite-' + index}
                      data={menuItem}
                      matchPages={matchPages}
                      icon={menuItem.icon}
                      scroll={scrollPosition}
                    />
                  )
                } else if (menuItem.p_ucc_page && menuItem.p_ucc_page.slug) {
                  return (
                    <InternalLink
                      key={'internalLink-navbar-page-' + index}
                      data={menuItem}
                      matchPages={matchPages}
                      icon={menuItem.icon}
                      scroll={scrollPosition}
                    />
                  )
                } else if (menuItem.url) {
                  return (
                    <ExternalLink
                      key={'externalLink-navbar-' + index}
                      data={menuItem}
                      icon={menuItem.icon}
                      scroll={scrollPosition}
                    />
                  )
                } else return null
              } else if (
                /********* Map para navItems dropdowns - Multiple Options *********/
                menuItem.pUccMicrosite?.find((item) => item.p_ucc_microsite.slug !== null) ||
                menuItem.pUccPages?.find((item) => item.p_ucc_page.slug !== null) ||
                menuItem.__component === "menu.pucc-career-feed-by-level" ||
                menuItem.ExternalLink ||
                menuItem.multipleSite
              ) {
                return (
                  <NavDropdown
                    title={`${menuItem.name}`}
                    id="index-navbar-nav"
                    key={`navBarId-${index}`}
                    className={`text-uppercase ${scrollPosition > 577 ? 'scroll-active' : ''}`}
                  >
                    {/* Map PUCC Pages */}
                    {menuItem.pUccPages &&
                      menuItem.pUccPages?.map((dropdown, index) => {
                        if (dropdown.p_ucc_page?.slug) {
                          return (
                            <div
                              className={`nav-scroll ${
                                scrollPosition > 577
                                  ? 'navbar-scroll-style2'
                                  : 'navbar-scroll-style'
                              }`}
                              key={'internalLink-navbar-page-' + index}
                            >
                              <InternalLink
                                data={dropdown}
                                matchPages={matchPages}
                                icon={dropdown.icon}
                                scroll={scrollPosition}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }
                    
                    {/* Map PUCC Microsites */}
                    {menuItem.pUccMicrosite &&
                      menuItem.pUccMicrosite?.map((dropdown, index) => {
                        if (dropdown.p_ucc_microsite?.slug) {
                          return (
                            <div
                              className={`nav-scroll ${
                                scrollPosition > 577
                                  ? 'navbar-scroll-style2'
                                  : 'navbar-scroll-style'
                              }`}
                              key={'internalLink-navbar-microsite-' + index}
                            >
                              <InternalLink
                                data={dropdown}
                                matchPages={matchPages}
                                icon={dropdown.icon}
                                scroll={scrollPosition}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    {/* Map PUCC Career Feed By Level */}
                    {menuItem.__component === "menu.pucc-career-feed-by-level" &&  
                      careerFeedByLevel.map((level, index) => {
                        return (
                          <div className="nav-scroll navbar-scroll-style2" key={`menuCareerFeedByLevelId-${index}`}>
                            <Link
                              to={`${level.slug}`}
                              className="dropdown-item"
                            >
                              <div className="text-wrap-lg text-uppercase mb-0 d-flex flex-row">
                                <small className="nav-text">
                                  {level.name}
                                </small>
                              </div>
                            </Link>
                          </div>  
                        )
                      })
                    }

                    {/* Map external links */}
                    {menuItem.ExternalLink &&
                      menuItem.ExternalLink?.map((dropdown, index) => {
                        if (dropdown?.url) {
                          return (
                            <div
                              className={`nav-scroll ${
                                scrollPosition > 577
                                  ? 'navbar-scroll-style2'
                                  : 'navbar-scroll-style'
                              }`}
                              key={'externalLink-navbar-' + index}
                            >
                              <ExternalLink
                                data={dropdown}
                                icon={dropdown.icon}
                                scroll={scrollPosition}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    {/* Map MultipleSites */}
                    {menuItem.multipleSite &&
                      <div
                        className={`nav-scroll ${
                          scrollPosition > 577
                            ? 'navbar-scroll-style2'
                            : 'navbar-scroll-style'
                        }`}
                      >
                        {menuItem.multipleSite?.map((dropdown, index) => {
                          switch (true) {
                            case dropdown.p_ucc_page !== null:
                              return (
                                <InternalLink
                                  key={'internalLink-navbar-page-' + index}
                                  data={dropdown}
                                  matchPages={matchPages}
                                  icon={dropdown.icon}
                                  scroll={scrollPosition}
                                />
                              )

                            case dropdown.p_ucc_microsite !== null:
                              return (
                                <InternalLink
                                  key={'internalLink-navbar-microsite-' + index}
                                  data={dropdown}
                                  matchPages={matchPages}
                                  icon={dropdown.icon}
                                  scroll={scrollPosition}
                                />
                              )

                            case dropdown.url !== null:
                              return (
                                <ExternalLink
                                  key={'externalLink-navbar-' + index}
                                  data={dropdown}
                                  icon={dropdown.icon}
                                  scroll={scrollPosition}
                                />
                              )
                          
                            case dropdown.p_ucc_career !== null:
                              return (
                                <InternalLink
                                  key={'internalLink-navbar-career-' + index}
                                  data={dropdown}
                                  matchPages={matchPages}
                                  icon={dropdown.icon}
                                  scroll={scrollPosition}
                                />
                              )

                            default:
                              return null
                          }
                        })}
                      </div>
                    }
                  </NavDropdown>
                )
              } else return null
            })}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

export default HeaderHome